import {
  createFormState,
  required,
  matchesField,
  hasLength,
  hasNumber,
  hasLowercaseLetter,
  hasUppercaseLetter,
  hasSpecialCharacter
} from "redux-freeform";

const formConfig = {
  password: {
    validators: [
      required(),
      hasLength(8, 100),
      hasNumber(),
      hasLowercaseLetter(),
      hasUppercaseLetter(),
      hasSpecialCharacter()
    ]
  },
  confirmPassword: {
    validators: [required(), matchesField("password")]
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formConfig
);
